import styled from 'styled-components';
import {device} from 'styled/device';
import {CustomIcon} from '@guestapp/ui';

export const StyledGuidebookData = styled.div`
  & h1,
  & h2,
  & h3 {
    padding: 0 0 8px;
  }

  width: 100%;
`;

export const MainText = styled.p`
  font-size: initial;
  color: initial;
`;

export const SecondaryText = styled.p`
  font-size: 14px;
  color: #6b6b95;
`;

export const TwoColumnLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 24px;

  @media (min-width: ${device.tabletM}) {
    grid-template-columns: 1fr 1fr;
    &.sidebar-left {
      grid-template-columns: 40fr 60fr;
    }

    &.sidebar-right {
      grid-template-columns: 60fr 40fr;
    }
  }

  & p,
  & h1,
  & h2,
  & h3 {
    margin: 0;
  }
`;

export const AmenitiesList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 4px;
  max-width: 848px;
`;

export const AmenityItem = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 16px;
  margin-bottom: 0;
  padding: 4px;
  & > * {
    margin-bottom: 0;
  }
`;

export const AmenityName = styled.div`
  color: ${props => props.theme.colors.branding.fontPrimary};
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const Divider = styled.div`
  background-color: rgba(0, 0, 0, 0.1);
  height: 1px;
`;

export const FileBox = styled.div`
  display: grid;
  grid-template-columns: 50px 365px 24px;
  gap: 16px;
  padding: 12px 16px;
  background-color: ${props => props.theme.colors.branding.backgroundSecondary};
  border-radius: 8px;
  width: 504px;
  align-items: center;
  margin-bottom: 24px;

  & .file-box__download-icon-container {
    cursor: pointer;
  }
`;

export const FileName = styled.p`
  color: ${props => props.theme.colors.branding.fontPrimary};
  font-size: ${props => props.theme.fonts.sizes.small};
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
`;

export const StyledHeading = styled.h1`
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
`;

export const ImageContainer = styled.div<{$align?: string}>`
  margin-bottom: 24px;
  text-align: ${props => props.$align || 'left'};
`;

export const BlockContainer = styled.div`
  margin-bottom: 24px;
`;

export const UnavailableIcon = styled(CustomIcon)`
  display: block;
  margin: 0 auto 40px;
  color: ${props => props.theme.colors.branding.primary};
`;
